module.exports = __webpack_public_path__ + "img/image5.f14d2740.png";